/* eslint-disable import/order */
import { currentUserResource } from '@jira/router-resources__current-user/src/useCurrentUserResource.tsx';
import { getAIContextPanelResources } from '@jira/router-resources__service-desk-ai-context-panel/src/getAIContextPanelResources.tsx';
// eslint-disable-next-line jira/import/no-restricted-import, camelcase
import { DEPRECATED_DO_NOT_USE_projectDetailsResource } from '@jira/router-resources__business-project-details/src/BusinessProjectDetailsUseProjectDEPRECATEDDONOTUSE.tsx';
import { forgeProjectModuleResource } from '@jira/navigation-apps__resources/src/controllers/forge/index.tsx';
import { staticSidebarDefaultPINFiltersResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/project-filters/index.tsx';
import { sidebarProjectIssuesResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/project-sidebar-common/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@jira/navigation-apps__resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import {
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
	issueNavigatorFilterRefinementRelayResource,
} from '@jira/router-resources__issue-navigator/src/issueNavigatorRelayResource.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { projectContextResource } from '@jira/router-resources__project-context/src/projectContextResource.tsx';
import { incidentExperimentTraitResource } from '@jira/router-resources__software-incidents/src/incidentExperimentTraitResource.tsx';
import { getDraftReplyPillsResource } from '@jira/router-resources__service-desk-draft-reply/src/getDraftReplyPillsResource.tsx';
import { projectThemeResource } from '@jira/router-resources__project-theme/src/projectThemeResource.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';
import { getIssueAppResources } from './getIssueAppResources.tsx';

export const getCommonProjectResources = ({
	isUsingSidebarEntrypoint,
}: {
	isUsingSidebarEntrypoint?: boolean;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
} = {}): RouteResource<any>[] => [
	issueNavigatorRelayResource,
	issueNavigatorFilterRelayResource,
	issueNavigatorHydrationRelayResource,
	issueNavigatorFilterRefinementRelayResource,
	...getNavigationResources({ isUsingSidebarEntrypoint }),
	...getIssueAppResources(),
	// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them if needed
	// A guide to check & cleanup: https://hello.atlassian.net/wiki/x/Q8XybwE
	incidentExperimentTraitResource,
	projectContextResource,
	forgeProjectModuleResource,
	staticProjectSidebarNavigationResource,
	staticProjectSidebarConnectAddonsNavigationResource,
	// end of resources expanded from getNavigationSidebarProjectResource
	// eslint-disable-next-line camelcase
	DEPRECATED_DO_NOT_USE_projectDetailsResource,
	projectThemeResource,
	sidebarProjectIssuesResource,
	staticSidebarDefaultPINFiltersResource,
	currentUserResource,
	...getAIContextPanelResources(),
	...getDraftReplyPillsResource(),
];
